import { ExpandTypesButton } from "./ExpandTypesButton";
import { Measurement } from "../measurement/Measurement";
import { MetricRow, MetricSubsection } from "./MetricSubsection";
import { Typography } from "@mui/material";
import { UnitNumberType } from "../../utils/units/units";
import { useTranslation } from "react-i18next";
import { WEED_FRACTION_OTHER_KEY } from "portal/utils/hooks/usePlantCategoryNames";
import { WeedMetrics } from "protos/portal/metrics";
import React, { FunctionComponent, useState } from "react";

// How many weed categories are visible before the list is truncated behind
// the "more types" button.
const MAX_COLLAPSED_WEED_TYPES = 5;

export const JigsawWeedFractions: FunctionComponent<{
  weedMetricsByCategory: { [id: string]: WeedMetrics };
}> = ({ weedMetricsByCategory }) => {
  const { t } = useTranslation();
  const [isExpanded, setExpanded] = useState<boolean>(false);

  const entries = Object.entries(weedMetricsByCategory).sort(
    ([aId, a], [bId, b]) => {
      // The combined "other" bucket always sorts last, regardless of size.
      return aId === WEED_FRACTION_OTHER_KEY
        ? 1
        : bId === WEED_FRACTION_OTHER_KEY
        ? -1
        : b.fractionOfTotal - a.fractionOfTotal;
    }
  );
  const visible = isExpanded
    ? entries
    : entries.slice(0, MAX_COLLAPSED_WEED_TYPES);

  return (
    <MetricSubsection>
      <MetricRow component={Typography} color="textSecondary" className="pb-1">
        {t("views.metrics.sections.weedType")}
      </MetricRow>
      {visible.map(([id, weed]) => (
        <MetricRow key={id}>
          <span className="font-medium">{weed.localizedName}</span>
          <Measurement
            unit={UnitNumberType.PERCENT}
            value={weed.fractionOfTotal * 100}
          />
        </MetricRow>
      ))}
      <ExpandTypesButton
        hiddenCount={entries.length - MAX_COLLAPSED_WEED_TYPES}
        isExpanded={isExpanded}
        setExpanded={setExpanded}
      />
    </MetricSubsection>
  );
};
